import { Component, Input, OnChanges, OnInit, Output, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ListComponent } from 'src/app/common/component/list.component';
import { DateService } from 'src/app/common/date.service';
import { Data2Service } from 'src/app/common/data2.service';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { GroupOfferPriceSettingDialogComponent } from '../group-offer-price-setting-dialog/group-offer-price-setting-dialog.component';
import { GroupOfferPriceSettingPublicationDialogComponent } from './group-offer-price-setting-publication-dialog/group-offer-price-setting-publication-dialog.component';
import { FormControl } from '@angular/forms';
import { UuidService } from 'src/app/common/uuid.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { LockerService } from 'src/app/common/locker.service';
import { GroupOfferPriceHistoryDialogComponent } from './group-offer-price-history-dialog/group-offer-price-history-dialog.component';
import { GroupOfferPriceFiltersComponent } from './group-offer-price-filters/group-offer-price-filters.component';
import { GroupOfferActivePriceSettingDialogComponent } from '../group-offer-active-price-setting-dialog/group-offer-active-price-setting-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { PricePipe } from '@/common/pipes/price.pipe';
import { BehaviorSubject, Subject, filter, takeUntil } from 'rxjs';
import { OfferTerm } from '@/reservation/reservation.model';
import { deepCompare } from '@/_utils/deep-compare';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';

@Component({
	selector: 'app-group-offer-price',
	templateUrl: './group-offer-price.component.html',
	styleUrls: ['./group-offer-price.component.css'],
	providers: [PricePipe],
})
export class GroupOfferPriceComponent extends ListComponent implements OnChanges, OnDestroy, OnInit {
	constructor(
		public dialog: MatDialog,
		protected locker: LockerService,
		protected uuid: UuidService,
		protected dateService: DateService,
		protected api: Data2Service,
		protected bag: DataBagService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected question: QuestionService,
		protected loader: LoaderService,
		private readonly pricePipe: PricePipe,
	) {
		super(api, bag, date, infobox, route, router, question, loader);
	}

	@Input() offerTerm;
	@Input() id;
	@Input() groupPriceSetting;
	@Input() displayedProducts: any;
	@Input() editable: boolean;
	@Input() userFilters: string;
	@Input() board: any;

	@Output() selected = new EventEmitter();
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(GroupOfferPriceFiltersComponent, { static: true })
	childFilters: GroupOfferPriceFiltersComponent;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	offerTerm$ = new BehaviorSubject<OfferTerm>(null);
	priceSettingsToUpdate = [];
	apiUrl = 'offer/term';
	matData = new MatTableDataSource<any>();
	selection = new SelectionModel(true, []);
	openHistory = false;
	displayedColumns: string[] = [
		`select`,
		`name`,
		`date`,
		`nights`,
		`board`,
		`catalogPrice`,
		`currentPrice`,
		`hourglass`,
		`status`,
		`promotionProcentage`,
		`promotionPrice`,
		`settings`,
		'kind',
	];
	parameters = {
		product: null,
		dateRange: null,
		nights: null,
		term_price_status: null,
		limit: '999',
	};

	termPriceAction: Array<any> = [
		{ id: 0, name: 'Podnieś o' },
		{ id: 1, name: 'Obniż o' },
		{ id: 2, name: 'Ustaw na' },
	];

	priceType = [
		{ id: 0, option: 'Katalogowa', type: 'K' },
		{ id: 1, option: 'Aktualna', type: 'A' },
	];

	selectedTermPriceAction = 0;
	selectedTermsId = 0;
	selectedPriceType = this.priceType[0];
	now = new Date().toJSON();
	holdCurrentPrice;
	holdPrice;
	oldOfferTerm;
	isEmptyForm = new FormControl('');
	readonly OfferTransportKind = OfferTransportKind;

	protected selectedTerms = [
		{ id: 0, option: 'Indywidualne ustawienia cenników' },
		{ id: 1, option: 'Zmiana ceny/ustawienie ceny' },
		{ id: 2, option: 'Ustawienia z grupy ofert' },
		{ id: 3, option: 'Ustawienia z produktu' },
	];

	protected optionSelected = false;
	protected selectedValue: string;
	protected termPriceValue: number;

	private readonly usedPriceSettings: any = [];
	private readonly destroy$ = new Subject<void>();

	ngOnChanges(): void {
		this.offerTerm$.next(this.offerTerm);
	}

	ngOnInit(): void {
		this.offerTerm$
			.pipe(
				filter((offer) => !deepCompare(offer, this.oldOfferTerm)),
				takeUntil(this.destroy$),
			)
			.subscribe((offer) => {
				this.oldOfferTerm = JSON.parse(JSON.stringify(offer));
				this.loadData();
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	fetchBoardCosts(boardIds: number[]): Promise<OfferTerm[]> {
		const requests = boardIds
			.filter((id) => !this.usedPriceSettings.includes((element) => element.id === id) && id !== null)
			.map(
				(boardId) =>
					new Promise<OfferTerm>((res, rej) => {
						this.bag.get(`/offer/price_setting/${boardId}/`, async (result, error) => {
							if (error) {
								return;
							}
							this.usedPriceSettings.push(result);
						});
					}),
			);

		return Promise.all(requests);
	}

	filtersChange(data): void {
		this.filtersSelected(data);
		this.selection.clear();
	}

	async loadData(): Promise<void> {
		this.loader.show();

		let offerTermCopy = JSON.parse(JSON.stringify(this.offerTerm));
		const parms: string = this.api.getChecked(this.filters, this.parameters);

		if (this.id == null) {
			return;
		}

		this.bag.get('/' + this.apiUrl + `/?limit=9999&group_offer=${this.id}&` + parms, async (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			offerTermCopy = this.convertData(result.results);
			offerTermCopy.forEach((item) => {
				if (item.termPrice != null) {
					this.currentPrice(item);
				}
			});

			//remove duplicate termPrice in the same term
			offerTermCopy = offerTermCopy.reduce((acc, current) => {
				const x = acc.find((item) => item.id === current.id);
				if (!x) {
					return acc.concat([current]);
				} else {
					return acc;
				}
			}, []);

			this.matData = new MatTableDataSource<any>(offerTermCopy);
			this.paginator._intl.itemsPerPageLabel = 'Liczba terminów na stronie';
			this.matData.paginator = this.paginator;
			this.matData.sort = this.sort;
			this.matData.sortingDataAccessor = (item, property) => {
				switch (property) {
					case 'name':
						return item.product.name;
					case 'date':
						return item.dateRange?.lower;
					case 'catalogPrice':
						return item.termPrice?.price;
					case 'currentPrice':
						return item.termPrice?.currentPrice;
					case 'nights':
						return this.countNights(item.dateRange?.lower, item.dateRange?.upper);
					default:
						return item[property];
				}
			};

			const boardIDs = [...new Set(offerTermCopy.map((term) => term.priceSettings.productPriceSettings))];

			await this.fetchBoardCosts(boardIDs as number[]);

			offerTermCopy.forEach((item) => {
				if (item.termPrice != null) {
					this.currentPrice(item);
				}
				item.dateRange.upper = this.dateService.daysAdd(-1, item.dateRange.upper);
				this.generatePriceSettingTooltip(item);
			});
		});
		this.loader.hide();
	}

	generatePriceSettingTooltip(item) {
		switch (item.pricePriority) {
			case 'T':
				if (item.priceSettings.termPriceSettings != null) {
					item['priceSettingTooltip'] = 'Ustawienia z terminu';

					if (item.priceSettings.termPriceSettings === 1) {
						item.product['boardTooltip'] = `Opublikuj zmiany, aby zobaczyć ustawioną cenę wyżywienia`;
						return;
					}

					this.termGetBoardCost(item.priceSettings.termPriceSettings, item);
				} else if (item.priceSettings.groupProductPriceSettings != null) {
					item['priceSettingTooltip'] = 'Ustawienia z grupy ofert';
					this.groupOfferBoardCost(item);
				} else {
					item['priceSettingTooltip'] = 'Ustawienia z produktu';

					this.termGetBoardCost(item.priceSettings.productPriceSettings, item);
				}
				break;
			case 'G':
				item['priceSettingTooltip'] = 'Ustawienia z grupy ofert';
				this.groupOfferBoardCost(item);
				break;
			case 'P':
				item['priceSettingTooltip'] = 'Ustawienia z produktu';
				this.termGetBoardCost(item.priceSettings.productPriceSettings, item);
				break;
			default:
				break;
		}
	}

	groupOfferBoardCost(item) {
		if (this.groupPriceSetting.priceSettingBoards == undefined) {
			return;
		}
		const selectedBoard = this.groupPriceSetting.priceSettingBoards.find(
			(findBoard) => findBoard.board.id == item.product.board,
		);
		if (selectedBoard == undefined || selectedBoard.isActive == false) {
			item.product['boardTooltip'] = `Nie ustawiono ceny dla tego wyżywienia lub jest nieaktywna`;
			return;
		}
		item.product['boardTooltip'] = `Cena sprzedaży: ${this.pricePipe.transform(selectedBoard.price)} PLN`;
	}

	setBoardPrice(priceSetting, item) {
		const selectedBoard = priceSetting.priceSettingBoards.find(
			(findBoard) => findBoard.board.id == item.product.board,
		);
		if (selectedBoard == undefined || selectedBoard.isActive == false) {
			item.product['boardTooltip'] = `Nie ustawiono ceny dla tego wyżywienia lub jest nieaktywna`;
			return;
		}
		item.product['boardTooltip'] = `Cena sprzedaży: ${this.pricePipe.transform(selectedBoard.price)} PLN`;
	}

	termGetBoardCost(boardId, item) {
		if (boardId == null) {
			item.product['boardTooltip'] = `Nie ustawiono ceny dla tego wyżywienia lub jest nieaktywna`;
			return;
		}

		const termPriceSetting = this.usedPriceSettings.find((item) => item.id === boardId);

		if (termPriceSetting) {
			this.setBoardPrice(termPriceSetting, item);
		}
	}

	currentPrice(term) {
		term.termPrice['currency'] = 'PLN';
		if (!term.promotions) {
			term.termPrice['currentPrice'] = term.termPrice.price;
			return;
		}
		if (term.promotions.method == 'amount') {
			term.termPrice['currentPrice'] = term.termPrice.price - term.promotions.value;
		} else {
			term.termPrice['currentPrice'] = term.termPrice.price - term.termPrice.price * term.promotions.value;
		}
	}

	datetimeWithTimezone(date: Date) {
		const dateString = new Date(date).toISOString();
		return {
			date: dateString.slice(0, 10),
			time: dateString.slice(11, 19),
			full: dateString,
		};
	}

	countNights(lowerDate, upperDate) {
		const countLowerDate: any = new Date(lowerDate);
		const countUpperDate: any = new Date(upperDate);
		countUpperDate.setDate(countUpperDate.getDate());
		if (!lowerDate && !upperDate) {
			return '';
		}
		return Math.ceil(Math.abs(countLowerDate - countUpperDate) / (1000 * 60 * 60 * 24));
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.matData.data.length;
		return numSelected === numRows;
	}

	toggleAllRows() {
		if (this.isAllSelected()) {
			this.selection.clear();
			return;
		}

		this.selection.select(...this.matData.data);
	}

	openPriceHistoryDialog(term) {
		this.dialog.open(GroupOfferPriceHistoryDialogComponent, {
			data: term,
			minWidth: '80vh',
		});
	}

	getBoard(element) {
		return this.board?.find((findBoard) => findBoard.id == element)?.name ?? '';
	}

	checkboxLabel(row): string {
		if (!row) {
			return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
		}
		return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
	}

	changeOption(optionId) {
		if (optionId == null) {
			this.optionSelected = false;
		} else {
			this.optionSelected = true;
		}
		if (optionId === undefined) {
			this.selectedTermsId = 0;
			return;
		}
		this.selectedTermsId = optionId;
	}

	checkOption() {
		this.isEmptyForm.markAsTouched();
		this.loader.show();
		if (this.selection.selected.length == 0) {
			this.infobox.warning('Nie zaznaczono żadnych terminów!');
			this.loader.hide();
			return;
		}

		switch (this.selectedTermsId) {
			case 0:
				this.openPriceSettingsDialog();
				break;
			case 1:
				this.globalCurrencyChange();
				break;
			case 2:
				this.changePriceSettings();
				break;
			case 3:
				this.changePriceSettings();
				break;
			default:
				break;
		}
	}

	openPriceSettingsDialog() {
		const dialogRef = this.dialog.open(GroupOfferPriceSettingDialogComponent, {
			data: this.selection.selected,
			maxHeight: '90vh',
			disableClose: true,
		});

		dialogRef.beforeClosed().subscribe((result) => {
			this.loader.show();
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result == false) {
				this.loader.hide();
				return;
			}
			this.selection.selected.map((item) => {
				this.generatePriceSettingTooltip(item);
			});
			this.loader.hide();
			this.table.renderRows();
		});

		return;
	}

	openActivePriceSettingsDialog(element) {
		const dialogRef = this.dialog.open(GroupOfferActivePriceSettingDialogComponent, {
			data: {
				termID: element.id,
			},
			maxHeight: '90vh',
		});

		return;
	}

	changeGroupProductPriceSettings(item) {
		if (item.priceSettings.groupProductPriceSettings == null) {
			this.infobox.error(
				'Niektóre z zaznaczonych terminów nie mają przypisanych żadnych ustawień cenników w grupie oferty',
			);
			return;
		}
		item.pricePriority = 'G';
	}

	changeProductPriceSettings(item) {
		if (item.priceSettings.productPriceSettings == null) {
			this.infobox.error(
				'Niektóre z zaznaczonych terminów nie mają przypisanych żadnych ustawień cenników w produkcie',
			);
			return;
		}
		item.pricePriority = 'P';
	}

	changePriceSettings() {
		this.selection.selected.map((item) => {
			let selectPriceSetting;
			if (this.selectedTermsId == 2) {
				this.changeGroupProductPriceSettings(item);
				selectPriceSetting = item.priceSettings.groupProductPriceSettings;
			} else {
				this.changeProductPriceSettings(item);
				selectPriceSetting = item.priceSettings.productPriceSettings;
			}
			if (selectPriceSetting == null) {
				return;
			}

			this.generatePriceSettingTooltip(item);
		});
		this.bag.put('/offer/term/bulk_update/', this.selection.selected, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
		});
		this.table.renderRows();
		this.loader.hide();
	}

	amountCurrencyChange(term) {
		const termPriceValue = this.termPriceValue * 100;
		switch (this.selectedTermPriceAction) {
			case 0:
				term.termPrice.price = term.termPrice.price + termPriceValue;
				if (term.promotions) {
					term.termPrice.currentPrice = term.termPrice.price - term.promotions.value;
					break;
				}
				term.termPrice.currentPrice = term.termPrice.price;
				break;
			case 1:
				term.termPrice.price = term.termPrice.price - termPriceValue;
				if (term.promotions) {
					term.termPrice.currentPrice = term.termPrice.price - term.promotions.value;
					break;
				}
				term.termPrice.currentPrice = term.termPrice.price;
				break;
			case 2:
				if (this.selectedPriceType.type == 'K') {
					term.termPrice.price = termPriceValue;
					if (term.promotions) {
						term.termPrice.currentPrice = term.termPrice.price - term.promotions.value;
						break;
					}
					term.termPrice.currentPrice = termPriceValue;
					return;
				}
				if (term.promotions) {
					term.termPrice.price = termPriceValue + term.promotions.value;
					term.termPrice.currentPrice = termPriceValue;
					break;
				}
				term.termPrice.price = termPriceValue;
				term.termPrice.currentPrice = termPriceValue;
				break;

			default:
				break;
		}
	}

	globalCurrencyChange() {
		if (this.termPriceValue == null) {
			this.infobox.error('Pole wartość nie może być puste');
			this.loader.hide();
			return;
		}
		this.selection.selected.forEach((item) => {
			let priceIsNull = false;
			if (item.termPrice == null) {
				item.termPrice = {
					currency: 'PLN',
					currentPrice: 0,
					id: null,
					price: 0,
					dateFrom: '',
					status: 'D',
				};
				priceIsNull = true;
			}

			this.holdPrice = item.termPrice.price;
			this.holdCurrentPrice = item.termPrice.currentPrice;
			if (item.termPrice != null) {
				switch (this.selectedPriceType.type) {
					case 'K':
						if (item.promotions && item.promotions.method == 'amount') {
							this.amountCurrencyChange(item);
						} else this.amountCurrencyChange(item);
						// jak będą promocje skończone to zrobię przeliczanie po procentach bo na razie jest stała wartość promocji 80 zł
						break;
					case 'A':
						if (item.promotions && item.promotions.method == 'amount') {
							this.amountCurrencyChange(item);
						} else this.amountCurrencyChange(item);
						// jak będą promocje skończone to zrobię przeliczanie po procentach bo na razie jest stała wartość promocji 80 zł
						break;

					default:
						break;
				}

				if (item.termPrice.price < 0 || item.termPrice.currentPrice < 0) {
					this.infobox.error(
						`Przy podanej konfiguracji cena katalogowa lub aktualna niektórych z zaznaczonych terminów będzie mniejsza od zera.`,
					);
					item.termPrice.price = this.holdPrice;
					item.termPrice.currentPrice = this.holdCurrentPrice;
					if (priceIsNull) {
						item.termPrice = null;
					}
					this.loader.hide();
					return;
				}
				const offerTermToUpdate = this.offerTerm.find((term) => term.id === item.id);
				item.termPrice.status = 'D';
				if (offerTermToUpdate) {
					offerTermToUpdate.termPrice = item.termPrice;
				}
				this.loader.hide();
			}
		});
	}

	openPublicationDialog() {
		const dialogRef = this.dialog.open(GroupOfferPriceSettingPublicationDialogComponent, {
			restoreFocus: false,
			data: [this.offerTerm, this.priceSettingsToUpdate, this.oldOfferTerm],
			minHeight: '10vh',
		});

		dialogRef.beforeClosed().subscribe((result) => {
			this.loader.show();
		});

		dialogRef.afterClosed().subscribe((result) => {
			// this.loadData();
			this.loader.hide();
			if (!result) {
				return;
			}
			this.selection.clear();
			this.childFilters.filtersClear();
			this.table.renderRows();
		});

		return;
	}
}
